import React from 'react';
import { AppState } from 'app/store';
import { Link } from 'types/api.types';
import { AsyncThunkAction } from '@reduxjs/toolkit';
import { KeySignatureMetadata, TimeSignatureMetadata } from 'types/song';
import { AxiosResponse } from 'axios';

interface MetadataMap {
  projectFile?: string;
  projectName?: string;
  location?: string;
  dateCreated?: string;
  durationSecs?: number;
  tempo?: number;
  keySignature?: KeySignatureMetadata;
  timeSignature?: TimeSignatureMetadata;
}

export interface DAWMetadata {
  metadata: MetadataMap;
  heuristicMetadata: MetadataMap;
}

export interface UseInfiniteLoaderProps {
  listId?: string;
  LoaderComponent?: React.ReactNode;
  dataLength: number;
  nextLinkSelector: (state: AppState) => Link | undefined;
  fetchNext: (next: Link) => AsyncThunkAction<any, any, any>;
}

export enum WebSocketEventCode {
  NORMAL_CLOSURE = 1000,
  GOING_AWAY = 1001,
}

export interface UseFetch<T, R = any | void> {
  callAPI: (url: string, payload?: T) => Promise<R>;
  isLoading: boolean;
  done: boolean;
  error: AxiosResponse | null;
  data: R | null;
}
